export const globalHeaders = { "Content-Type": "application/json" };

export function setGlobalHeader(name, value) {
  globalHeaders[name] = value;
}
